// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner_banner__GAFX_","_typography":"banner__typography__7gT0_","order_summary":"banner_order_summary__qpsdo","breadcrumb":"banner_breadcrumb__Gw972"};